import { NgModule } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { InsideSurveyComponent } from "./inside-survey/components/inside-survey/inside-survey.component";
import { InsideSurveyModule } from "./inside-survey/inside-survey.module";
import { OutsideSurveyComponent } from "./outside-survey/outside-survey.component";
import { OutsideSurveyModule } from "./outside-survey/outside-survey.module";
import { SurveyOchestratorComponent } from "./survey-ochestrator/survey-ochestrator.component";
import { ViewOrchestratorDirective } from "./view-orchestrator/view-orchestrator.component";
@NgModule({
  declarations: [SurveyOchestratorComponent, ViewOrchestratorDirective],
  imports: [InsideSurveyModule, OutsideSurveyModule, MatIconModule],
  entryComponents: [OutsideSurveyComponent, InsideSurveyComponent],
})
export class SurveyModule {}
